module.exports = __webpack_public_path__ + "media/images/common/body_bg-b315f1f5a1edcf9b52cbe1e692966220.gif";